import { createModalsFactory } from 'ui';

import { EditPeerPageModalIds, EditPeerPageModalMeta } from './EditPeerPage.types';

const {
  Provider: EditPeerPageModalProvider,
  useProvider: useEditPeerPageModalProvider,
  ModalTitleWithBackButton,
} = createModalsFactory<EditPeerPageModalIds[], EditPeerPageModalMeta>([
  'base',
  'bannerImage',
  'description',
  'notifications',
  'goal',
]);

export { EditPeerPageModalProvider, ModalTitleWithBackButton, useEditPeerPageModalProvider };
